module Client.Components.PurchaseOrderNumberEntry

open Client
open Client.Services
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.SweetAlert
open Feliz.UseElmish
open Fable.Core.Experimental
open Fable.Core.JS
open CustomerDexImaging.Models

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some s
type FieldState =
  { Validate : bool
    FieldValue : string option } with
    static member defaultValue =
      { Validate = false; FieldValue = None }
    static member init v =
      { Validate = false; FieldValue = v }
    member this.setValue v =
      { Validate = true; FieldValue = v }

type EntryState =
  { PurchaseOrderNumber : FieldState } with
    member this.validate () =
      match this.PurchaseOrderNumber.FieldValue with
      | Some v ->
        v |> Ok
      | _ -> Error "Please ensure all required fields are populated."
    member this.isValid () =
      match this.validate() with
      | Ok _ -> true
      | Error _ -> false
    static member defaultValue =
      { PurchaseOrderNumber = FieldState.defaultValue }

let view = React.functionComponent (fun (inputProps: {| returnResult: string -> unit; |}) ->
  let state, setState = React.useState(EntryState.defaultValue)
  let warningState, setWarningState = React.useState<string option> None
  let classes = Styles.useStyles()
  Html.div [
    Mui.grid [
      grid.container true
      grid.direction.column
      grid.spacing._2
      grid.children [
        Mui.grid [
          grid.item true
          grid.children [
            Html.text "Please enter purchase order number."
          ]
        ]
        Mui.grid [
          grid.item true
          grid.children [
            Html.form [
              prop.children [
                Mui.textField [
                  textField.placeholder "Purchase order number"
                  textField.variant.outlined
                  textField.margin.normal
                  textField.fullWidth true
                  textField.label "Purchase order number"
                  textField.name "PurchaseOrderNumber"
                  textField.required true
                  textField.onChange (fun (ev : Browser.Types.Event) -> setState { state with PurchaseOrderNumber = strOption !!ev.target?value |> state.PurchaseOrderNumber.setValue })
                ]
                Html.div [
                  prop.className classes.wrapper
                  prop.children [
                    Mui.button [
                      prop.type'.submit
                      button.fullWidth true
                      button.variant.contained
                      button.color.primary
                      button.children "Submit PO number"
                      button.disabled (state.isValid() |> not)
                      prop.onClick (fun e ->
                        e.preventDefault ()
                        match state.validate() with
                        | Ok v -> inputProps.returnResult v
                        | Error msg -> setWarningState (Some msg)
                      )
                    ]
                  ]
                ]
                if warningState.IsSome then Html.text warningState.Value else Html.none
              ]
            ]
          ]
        ]
      ]
    ]
  ]
)